var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
import { asNumber } from "@/lib/number-utils";
import { ENDPOINTS } from "./config";
import { FORMULAS } from "@/lib/formulas";
import { currentUser } from "@/core/users/session";
import { formatLevanteData } from "../lib/zones/levante";
// Helper para detectar si es Norte
function isNorthData(row) {
    return currentUser().area_code === "N";
}
// Helper para detectar si es Catalunya
function isCatalunyaData(row, table) {
    const catalunya_region_codes = ["E100"];
    return catalunya_region_codes.includes(currentUser().region_code) && table !== 'catalunya_rpv';
}
// Helper para detectar si es Catalunya
function isCatalunyaRPVData(row, table) {
    const catalunya_region_codes = ["E100"];
    return catalunya_region_codes.includes(currentUser().region_code) && table === 'catalunya_rpv';
}
function isCanariasData(row) {
    return currentUser().region_code === "S300";
}
function isLevanteData(row) {
    return currentUser().region_code === "E300";
}
function isMadridData(row) {
    return currentUser().region_code === "C100";
}
function isBalearesData(row) {
    return currentUser().region_code === "E200";
}
const catalunyaCurvaCache = {};
function fetchCatalunyaCurva(ano_natural, mes_natural) {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheKey = `${ano_natural || "default"}_${mes_natural || "default"}`;
        if (catalunyaCurvaCache[cacheKey]) {
            return catalunyaCurvaCache[cacheKey];
        }
        catalunyaCurvaCache[cacheKey] = (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const params = {};
                if (ano_natural)
                    params.ano_natural = ano_natural;
                if (mes_natural)
                    params.mes_natural = mes_natural;
                const response = yield HttpClient.get("/webapi/data/catalunya-curva-kpi-cats", params);
                if ((response === null || response === void 0 ? void 0 : response.data) && Array.isArray(response.data)) {
                    return response.data;
                }
            }
            catch (error) {
                console.error("Error fetching catalunya curva data:", error);
                delete catalunyaCurvaCache[cacheKey];
            }
            return [];
        }))();
        return catalunyaCurvaCache[cacheKey];
    });
}
function computeCatalunyaCurva(porcentajeConseguido, ano_natural, mes_natural) {
    return __awaiter(this, void 0, void 0, function* () {
        const rowsCurva = yield fetchCatalunyaCurva(ano_natural, mes_natural);
        if (!rowsCurva.length) {
            return 0;
        }
        const roundedCoverage = Number(porcentajeConseguido.toFixed(2));
        const matchingRow = rowsCurva.find((row) => Number(asNumber(row.cobertura).toFixed(2)) === roundedCoverage);
        return matchingRow ? normalizeCatalunyaPercentage(asNumber(matchingRow.retribucion)) : 0;
    });
}
function hasValue(value) {
    return value !== null && value !== undefined && value !== "";
}
function normalizeCatalunyaRedRevisada(value) {
    if (!hasValue(value)) {
        return null;
    }
    return normalizeCatalunyaPercentage(asNumber(value));
}
function normalizeCatalunyaPercentage(value) {
    return value > 0 && value <= 1 ? value * 100 : value;
}
export function fetchMadridRpvMinMax(period) {
    return __awaiter(this, void 0, void 0, function* () {
        return HttpClient.get("/webapi/resultados/madrid-rpv-minmax", { ano_natural: period.year, mes_natural: period.month });
    });
}
export function fetchReportData(period, table) {
    return __awaiter(this, void 0, void 0, function* () {
        let month = period.month;
        if (currentUser().region_code === "E300") {
            if (month == 1 || month == 2 || month == 3) {
                month = '1,2,3';
            }
            else if (month == 4 || month == 5 || month == 6) {
                month = '4,5,6';
            }
            else if (month == 7 || month == 8 || month == 9) {
                month = '7,8,9';
            }
            else if (month == 10 || month == 11 || month == 12) {
                month = '10,11,12';
            }
        }
        const response = yield HttpClient.get(ENDPOINTS.FETCH_REPORT_DATA, {
            ano_natural: period.year,
            mes_natural: month,
            table: table
        });
        let rpvMinMax;
        if (currentUser().region_code === "C100") {
            rpvMinMax = yield fetchMadridRpvMinMax(period);
        }
        return Promise.all(response.map((row) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            // Detectar si es Norte
            if (isNorthData(row)) {
                // Datos de NORTE
                const clientes_productivos = yield FORMULAS.clientes_north({
                    periodo_actual: asNumber(row.clientes_productivos.cliente_esp_aact),
                    periodo_anterior: asNumber(row.clientes_productivos.clientes_esp_aant),
                    objetivo_porcentaje: asNumber(row.clientes_productivos.propuesta_objetivos_1rkpi),
                    objetivo_cf: row.clientes_productivos.objetivo_cf !== undefined ? asNumber(row.clientes_productivos.objetivo_cf) : undefined,
                    ano_natural: period.year,
                    mes_natural: period.month,
                });
                clientes_productivos['red_revisada'] = (_a = row.clientes_productivos.red_revisada_ant) !== null && _a !== void 0 ? _a : row.clientes_productivos.red_revisada;
                const cf_vidrio_retornable = yield FORMULAS.volumen_north({
                    periodo_actual: asNumber(row.cf_vidrio_retornable.vol_esp_aact),
                    periodo_anterior: asNumber(row.cf_vidrio_retornable.vol_esp_aant),
                    objetivo_porcentaje: asNumber(row.cf_vidrio_retornable.propuesta_2nkpi),
                    objetivo_cf: row.cf_vidrio_retornable.objetivo_cf !== undefined ? asNumber(row.cf_vidrio_retornable.objetivo_cf) : undefined,
                    ano_natural: period.year,
                    mes_natural: period.month,
                });
                cf_vidrio_retornable['red_revisada'] = (_b = row.cf_vidrio_retornable.red_revisada_ant) !== null && _b !== void 0 ? _b : row.cf_vidrio_retornable.red_revisada;
                // Solo calcular rutas_cfl_clientes_fuze_mantener si existe (región N300)
                const rutas_cfl_clientes_fuze_mantener = row.rutas_cfl_clientes_fuze_mantener
                    ? yield FORMULAS.clientes_north_fuze({
                        periodo_actual: asNumber(row.rutas_cfl_clientes_fuze_mantener.clientes_esp_1_aact),
                        periodo_anterior: asNumber(row.rutas_cfl_clientes_fuze_mantener.clientes_esp_1_aant),
                        ano_natural: period.year,
                        mes_natural: period.month,
                    })
                    : undefined;
                if (rutas_cfl_clientes_fuze_mantener) {
                    rutas_cfl_clientes_fuze_mantener['red_revisada'] = (_c = row.rutas_cfl_clientes_fuze_mantener.red_revisada_ant) !== null && _c !== void 0 ? _c : row.rutas_cfl_clientes_fuze_mantener.red_revisada;
                }
                const red_total_clientes_productivos_red = clientes_productivos['red_revisada'] != null
                    ? asNumber(clientes_productivos['red_revisada']) / 100
                    : clientes_productivos.porcentaje_red;
                const red_total_cf_vidrio_retornable_red = cf_vidrio_retornable['red_revisada'] != null
                    ? asNumber(cf_vidrio_retornable['red_revisada']) / 100
                    : cf_vidrio_retornable.porcentaje_red;
                // Caso base 0/0: si no hay clientes Fuze (ni actual ni anterior), el KPI Fuze
                // no debe puntuar. Se excluye (null) para que red_total reparta 50/50 Clientes/CF.
                const fuzeSinBase = rutas_cfl_clientes_fuze_mantener != null
                    && asNumber(rutas_cfl_clientes_fuze_mantener.periodo_actual) === 0
                    && asNumber(rutas_cfl_clientes_fuze_mantener.periodo_anterior) === 0;
                const red_total_fuze_red = (rutas_cfl_clientes_fuze_mantener == null || fuzeSinBase)
                    ? null
                    : (rutas_cfl_clientes_fuze_mantener['red_revisada'] != null
                        ? asNumber(rutas_cfl_clientes_fuze_mantener['red_revisada']) / 100
                        : (_d = rutas_cfl_clientes_fuze_mantener.porcentaje_red) !== null && _d !== void 0 ? _d : null);
                const red_total = red_total_fuze_red != null
                    ? red_total_clientes_productivos_red * 0.5 + red_total_cf_vidrio_retornable_red * 0.5 * (14 / 15) + red_total_fuze_red * 0.5 * (1 / 15)
                    : red_total_clientes_productivos_red * 0.5 + red_total_cf_vidrio_retornable_red * 0.5;
                const canonPeriodoActual = asNumber(row.canon_2025.cajas_aact);
                const canonPeriodoAnterior = asNumber(row.canon_2025.cajas_aant);
                const canon_variable = {
                    periodo_actual: canonPeriodoActual,
                    periodo_anterior: canonPeriodoAnterior,
                    porcentaje_crecimiento: canonPeriodoAnterior !== 0 ? (canonPeriodoActual / canonPeriodoAnterior) - 1 : 0,
                    red_total: red_total,
                    comision: asNumber(row.comision),
                    importe_total: red_total * canonPeriodoActual * asNumber(row.comision)
                };
                return Object.assign(Object.assign({ region_de_ventas: row.region_de_ventas, delegacion: row.delegacion, sala: row.sala, delegacion_zona_de_ventas: row.delegacion_zona_de_ventas, distribuidor: row.distribuidor, clientes_productivos,
                    cf_vidrio_retornable,
                    canon_variable }, (rutas_cfl_clientes_fuze_mantener && { rutas_cfl_clientes_fuze_mantener })), { ano_natural: period.year, mes_natural: period.month });
            }
            else if (isCanariasData(row)) {
                const incremento_total_ventas_cu = FORMULAS.canarias_growth_py_percent({
                    periodo_actual: asNumber((_e = row.incremento_total_ventas_cu.vol_aact) !== null && _e !== void 0 ? _e : row.incremento_total_ventas_cu.clientes_aact),
                    periodo_anterior: asNumber((_f = row.incremento_total_ventas_cu.vol_aant) !== null && _f !== void 0 ? _f : row.incremento_total_ventas_cu.clientes_aant),
                    objetivo_porcentaje: row.incremento_total_ventas_cu.propuesta_1nkpi
                });
                const total_vidrio_retornable_mdo_local = FORMULAS.canarias_growth_py_percent({
                    periodo_actual: asNumber((_g = row.total_vidrio_retornable_mdo_local.vol_esp_aact) !== null && _g !== void 0 ? _g : row.total_vidrio_retornable_mdo_local.clientes_esp_aact),
                    periodo_anterior: asNumber((_h = row.total_vidrio_retornable_mdo_local.vol_esp_aant) !== null && _h !== void 0 ? _h : row.total_vidrio_retornable_mdo_local.clientes_esp_aant),
                    objetivo_porcentaje: row.total_vidrio_retornable_mdo_local.propuesta_2nkpi
                });
                const crecer_volumen_fuze_te = FORMULAS.canarias_growth_py_percent({
                    periodo_actual: asNumber((_j = row.crecer_volumen_fuze_te.vol_esp_1_aact) !== null && _j !== void 0 ? _j : row.crecer_volumen_fuze_te.clientes_esp_1_aact),
                    periodo_anterior: asNumber((_k = row.crecer_volumen_fuze_te.vol_esp_1_aant) !== null && _k !== void 0 ? _k : row.crecer_volumen_fuze_te.clientes_esp_1_aant),
                    objetivo_porcentaje: row.crecer_volumen_fuze_te.propuesta_3nkpi
                });
                const crecer_clientes_compradores = FORMULAS.canarias_clientes_compradores({
                    periodo_actual: asNumber((_o = (_m = (_l = row.crecer_clientes_compradores.clientes_esp_2_aact) !== null && _l !== void 0 ? _l : row.crecer_clientes_compradores.clientes_aact) !== null && _m !== void 0 ? _m : row.crecer_clientes_compradores.vol_aact) !== null && _o !== void 0 ? _o : row.crecer_clientes_compradores.vol_esp_2_aact),
                    periodo_anterior: asNumber((_r = (_q = (_p = row.crecer_clientes_compradores.clientes_esp_2_aant) !== null && _p !== void 0 ? _p : row.crecer_clientes_compradores.clientes_aant) !== null && _q !== void 0 ? _q : row.crecer_clientes_compradores.vol_aant) !== null && _r !== void 0 ? _r : row.crecer_clientes_compradores.vol_esp_2_aant),
                    objetivo_porcentaje: row.crecer_clientes_compradores.propuesta_4kpi,
                });
                return {
                    delegacion: row.delegacion,
                    sala: row.sala,
                    delegacion_zona_de_ventas: row.delegacion_zona_de_ventas,
                    distribuidor: row.distribuidor,
                    incremento_total_ventas_cu,
                    total_vidrio_retornable_mdo_local,
                    crecer_volumen_fuze_te,
                    crecer_clientes_compradores,
                    kpi_slot_1_type: row.kpi_slot_1_type,
                    kpi_slot_2_type: row.kpi_slot_2_type,
                    kpi_slot_3_type: row.kpi_slot_3_type,
                    kpi_slot_4_type: row.kpi_slot_4_type,
                    ano_natural: period.year,
                    mes_natural: period.month,
                };
            }
            // Detectar si es Catalunya
            else if (isCatalunyaData(row, table)) {
                // Datos de CATALUNYA
                const volumenPorcentajeConseguido = asNumber(row.volumen_catalunya.vol_esp_aant) > 0
                    ? (asNumber(row.volumen_catalunya.vol_esp_aact) / (asNumber(row.volumen_catalunya.vol_esp_aant) + (asNumber(row.volumen_catalunya.vol_esp_aant) * (asNumber(row.volumen_catalunya.propuesta_1rkpi) / 100))))
                    : 0;
                const clientesPorcentajeConseguido = asNumber(row.clientes_catalunya.clientes_esp_aant) > 0
                    ? (asNumber(row.clientes_catalunya.clientes_esp_aact) / (asNumber(row.clientes_catalunya.clientes_esp_aant) + (asNumber(row.clientes_catalunya.clientes_esp_aant) * asNumber(row.clientes_catalunya.propuesta_2nkpi) / 100)))
                    : 0;
                const cilindrosPorcentajeConseguido = asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior) > 0
                    ? (asNumber(row.cilindros_refrescos_vr_catalunya.periodo_actual) / (asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior) + (asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior) * asNumber(row.cilindros_refrescos_vr_catalunya.propuesta_3rkpi) / 100)))
                    : 0;
                const [volumenCurva, clientesCurva, cilindrosCurva] = yield Promise.all([
                    computeCatalunyaCurva(volumenPorcentajeConseguido, period.year, period.month),
                    computeCatalunyaCurva(clientesPorcentajeConseguido, period.year, period.month),
                    computeCatalunyaCurva(cilindrosPorcentajeConseguido, period.year, period.month),
                ]);
                const volumen_catalunya = {
                    periodo_actual: asNumber(row.volumen_catalunya.vol_esp_aact),
                    periodo_anterior: asNumber(row.volumen_catalunya.vol_esp_aant),
                    objetivo_porcentaje: asNumber(row.volumen_catalunya.propuesta_1rkpi),
                    objetivo_cu: Math.round(asNumber(row.volumen_catalunya.vol_esp_aant) + (asNumber(row.volumen_catalunya.vol_esp_aant) * (asNumber(row.volumen_catalunya.propuesta_1rkpi) / 100))),
                    porcentaje_conseguido: volumenPorcentajeConseguido,
                    porcentaje_red: volumenCurva,
                    red_revisada: normalizeCatalunyaRedRevisada(hasValue(row.volumen_catalunya.red_revisada_ant)
                        ? row.volumen_catalunya.red_revisada_ant
                        : row.volumen_catalunya.red_revisada),
                };
                const clientes_catalunya = {
                    periodo_actual: asNumber(row.clientes_catalunya.clientes_esp_aact),
                    periodo_anterior: asNumber(row.clientes_catalunya.clientes_esp_aant),
                    objetivo_porcentaje: asNumber(row.clientes_catalunya.propuesta_2nkpi),
                    objetivo_cu: Math.round(asNumber(row.clientes_catalunya.clientes_esp_aant) + (asNumber(row.clientes_catalunya.clientes_esp_aant) * asNumber(row.clientes_catalunya.propuesta_2nkpi) / 100)),
                    porcentaje_conseguido: clientesPorcentajeConseguido,
                    porcentaje_red: clientesCurva,
                    red_revisada: normalizeCatalunyaRedRevisada(hasValue(row.clientes_catalunya.red_revisada_ant)
                        ? row.clientes_catalunya.red_revisada_ant
                        : row.clientes_catalunya.red_revisada),
                };
                const cilindros_refrescos_vr_catalunya = {
                    periodo_actual: asNumber(row.cilindros_refrescos_vr_catalunya.periodo_actual),
                    periodo_anterior: asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior),
                    objetivo_porcentaje: asNumber(row.cilindros_refrescos_vr_catalunya.propuesta_3rkpi),
                    objetivo_cu: Math.round(asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior) + (asNumber(row.cilindros_refrescos_vr_catalunya.periodo_anterior) * asNumber(row.cilindros_refrescos_vr_catalunya.propuesta_3rkpi) / 100)),
                    porcentaje_conseguido: cilindrosPorcentajeConseguido,
                    porcentaje_red: cilindrosCurva,
                    red_revisada: normalizeCatalunyaRedRevisada(hasValue(row.cilindros_refrescos_vr_catalunya.red_revisada_ant)
                        ? row.cilindros_refrescos_vr_catalunya.red_revisada_ant
                        : row.cilindros_refrescos_vr_catalunya.red_revisada),
                };
                const redencionCalculada = ((_s = volumen_catalunya.red_revisada) !== null && _s !== void 0 ? _s : volumen_catalunya.porcentaje_red) * 0.4 +
                    ((_t = clientes_catalunya.red_revisada) !== null && _t !== void 0 ? _t : clientes_catalunya.porcentaje_red) * 0.4 +
                    ((_u = cilindros_refrescos_vr_catalunya.red_revisada) !== null && _u !== void 0 ? _u : cilindros_refrescos_vr_catalunya.porcentaje_red) * 0.2;
                const volumenResultados = volumen_catalunya.periodo_actual;
                const comisionResultados = asNumber(row.comision);
                const resultados = {
                    redencion_total: redencionCalculada,
                    redencion_revisada: redencionCalculada,
                    volumen: volumenResultados,
                    comision: comisionResultados,
                    importe_total: (redencionCalculada / 100) * volumenResultados * comisionResultados,
                };
                return {
                    delegacion: row.delegacion,
                    delegacion_zona_de_ventas: row.delegacion,
                    distribuidor: row.distribuidor,
                    volumen_catalunya,
                    clientes_catalunya,
                    cilindros_refrescos_vr_catalunya,
                    resultados,
                    ano_natural: period.year,
                    mes_natural: period.month,
                };
            }
            else if (isCatalunyaRPVData(row, table)) {
                // Datos de CATALUNYA RPV
                const propuestaObjetivos1rkpi = (_w = (_v = row.volumen_catalunya_rpv.propuesta_objetivos_1rkpi) !== null && _v !== void 0 ? _v : row.volumen_catalunya_rpv.propuesta_1rkpi) !== null && _w !== void 0 ? _w : row.volumen_catalunya_rpv.propuesta_objetivo_1rkpi;
                const volumen_catalunya_rpv = FORMULAS.volumen({
                    periodo_actual: asNumber(row.volumen_catalunya_rpv.vol_aact),
                    periodo_anterior: asNumber(row.volumen_catalunya_rpv.vol_aant),
                    objetivo_porcentaje: asNumber(propuestaObjetivos1rkpi) / 100,
                });
                const clientes_catalunya_rpv = FORMULAS.clientes_catalunya_rpv({
                    periodo_actual: asNumber(row.compradores_catalunya_rpv.clientes_aact),
                    periodo_anterior: asNumber(row.compradores_catalunya_rpv.clientes_aant)
                });
                const ref_prom_catalunya_rpv = FORMULAS.ref_promedio_catalunya_rpv({
                    periodo_actual: asNumber(row.ref_prom_catalunya_rpv.prom_refrx_cliente_aact),
                    periodo_anterior: asNumber(row.ref_prom_catalunya_rpv.prom_refrx_cliente_aant),
                    objetivo_porcentaje: asNumber(row.ref_prom_catalunya_rpv.propuesta_objetivos_3rkpi)
                });
                const volumen_esp_catalunya_rpv = FORMULAS.comprad({
                    vol_aact: asNumber(row.volumen_esp_catalunya_rpv.vol_esp_aact),
                    vol_aant: asNumber(row.volumen_esp_catalunya_rpv.vol_esp_aant)
                });
                const clientes_esp_catalunya_rpv = FORMULAS.media_consecucion_objetivos({
                    clientes_aact: asNumber(row.clientes_esp_catalunya_rpv.clientes_esp_aact),
                    clientes_aant: asNumber(row.clientes_esp_catalunya_rpv.clientes_esp_aant)
                });
                return {
                    delegacion: row.delegacion,
                    delegacion_zona_de_ventas: row.delegacion,
                    distribuidor: row.distribuidor,
                    volumen_catalunya_rpv,
                    clientes_catalunya_rpv,
                    ref_prom_catalunya_rpv,
                    volumen_esp_catalunya_rpv,
                    clientes_esp_catalunya_rpv,
                    ano_natural: period.year,
                    mes_natural: period.month,
                };
            }
            else if (isLevanteData(row)) {
                return yield formatLevanteData(row);
            }
            else if (isMadridData(row)) {
                const rowRpvMinMax = rpvMinMax[row.delegacion_zona_de_ventas];
                const volumen_mad = FORMULAS.madrid_result({
                    periodo_actual: asNumber(row.volumen.mes_year_actual),
                    min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.volumen.min,
                    max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.volumen.max
                });
                const volumen_acumulado_mad = Object.assign(Object.assign({}, FORMULAS.madrid_result({
                    periodo_actual: asNumber(row.volumen_acumulado.acumulado_year_actual),
                    min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.volumen_acum.min,
                    max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.volumen_acum.max
                })), { porcentaje_conseguido: FORMULAS.madrid_pct_yoy_acum({
                        vol_acum_aact: asNumber(row.volumen_acumulado.acumulado_year_actual),
                        vol_acum_aant: asNumber(row.volumen_acumulado.acumulado_year_anterior),
                        bp_acum: asNumber(row.volumen_acumulado.objetivo),
                    }) });
                const clientes_mad = Object.assign(Object.assign({}, FORMULAS.madrid_result({
                    periodo_actual: asNumber(row.clientes.clientes_mes_actual),
                    min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.compradores.min,
                    max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.compradores.max
                })), { porcentaje_conseguido: FORMULAS.madrid_pct_compradores({
                        clientes_mes_actual: asNumber(row.clientes.clientes_mes_actual),
                        clientes_mes_anterior: asNumber(row.clientes.clientes_mes_anterior),
                    }) });
                const refPromedioCrecimiento = FORMULAS.center_madrid_ref_promedio({
                    periodo_actual: asNumber(row.ref_promedio.ref_mes_year_actual),
                    periodo_anterior: asNumber(row.ref_promedio.ref_mes_year_anterior)
                });
                const ref_promedio_mad = Object.assign(Object.assign(Object.assign({}, refPromedioCrecimiento), FORMULAS.madrid_result({
                    periodo_actual: refPromedioCrecimiento.porcentaje_crecimiento,
                    min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.ref_prom.min,
                    max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.ref_prom.max
                })), { del_prom: asNumber(row.ref_promedio.del_prom_aact) });
                const cajasVentaBruta = asNumber(row.cajas_regalo.venta_bruta_aact);
                const cajasRatio = cajasVentaBruta !== 0
                    ? (asNumber(row.cajas_regalo.venta_bruta_cajas_regalo) / cajasVentaBruta) * 100
                    : 0;
                const cajasRegaloResult = FORMULAS.cajas_regalo_result({
                    periodo_actual: cajasRatio,
                    min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.cajas_regalo.min,
                    max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.cajas_regalo.max
                });
                const cajas_regalo_mad = Object.assign(Object.assign(Object.assign({}, cajasRegaloResult), FORMULAS.cajas_regalo({
                    venta_bruta_aact: asNumber(row.cajas_regalo.venta_bruta_aact),
                    venta_bruta_cajas_regalo: asNumber(row.cajas_regalo.venta_bruta_cajas_regalo)
                })), { porcentaje_conseguido: cajasRegaloResult.result });
                const gda_mad = {
                    gda_ho_f1: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo1) === null || _a === void 0 ? void 0 : _a.rtdo_ho_f1);
                        const obj = asNumber((_b = row.GDA.Grupo1) === null || _b === void 0 ? void 0 : _b.obj_ho_f1);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f1.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f1.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                    gda_ho_f2: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo2) === null || _a === void 0 ? void 0 : _a.rtdo_ho_f2);
                        const obj = asNumber((_b = row.GDA.Grupo2) === null || _b === void 0 ? void 0 : _b.obj_ho_f2);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f2.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f2.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                    gda_ho_f3: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo3) === null || _a === void 0 ? void 0 : _a.rtdo_ho_f3);
                        const obj = asNumber((_b = row.GDA.Grupo3) === null || _b === void 0 ? void 0 : _b.obj_ho_f3);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f3.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_ho_f3.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                    gda_al_f1: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo4) === null || _a === void 0 ? void 0 : _a.rtdo_al_f1);
                        const obj = asNumber((_b = row.GDA.Grupo4) === null || _b === void 0 ? void 0 : _b.obj_al_f1);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f1.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f1.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                    gda_al_f2: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo5) === null || _a === void 0 ? void 0 : _a.rtdo_al_f2);
                        const obj = asNumber((_b = row.GDA.Grupo5) === null || _b === void 0 ? void 0 : _b.obj_al_f2);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f2.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f2.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                    gda_al_f3: (() => {
                        var _a, _b;
                        const rtdo = asNumber((_a = row.GDA.Grupo6) === null || _a === void 0 ? void 0 : _a.rtdo_al_f3);
                        const obj = asNumber((_b = row.GDA.Grupo6) === null || _b === void 0 ? void 0 : _b.obj_al_f3);
                        return Object.assign(Object.assign({}, FORMULAS.madrid_result({ periodo_actual: rtdo, min: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f3.min, max: rowRpvMinMax === null || rowRpvMinMax === void 0 ? void 0 : rowRpvMinMax.gda_al_f3.max })), { porcentaje_conseguido: FORMULAS.madrid_pct_gda({ rtdo, obj }), _obj: obj });
                    })(),
                };
                return {
                    delegacion_zona_de_ventas: row.delegacion_zona_de_ventas,
                    delegacion: row.delegacion,
                    zona_de_ventas: row.zona_de_ventas,
                    distribuidor: row.distribuidor,
                    volumen_mad,
                    volumen_acumulado_mad,
                    clientes_mad,
                    ref_promedio_mad,
                    cajas_regalo_mad,
                    gda_mad,
                    // Valores crudos necesarios para la agregacion de totales por delegacion (T7)
                    _raw_cajas_regalo: asNumber(row.cajas_regalo.venta_bruta_cajas_regalo),
                    _raw_aact_cajas_regalo: asNumber(row.cajas_regalo.venta_bruta_aact),
                };
            }
            else if (isBalearesData(row)) {
                // Datos de BALEARES
                const volumen_total_distribucion_baleares = Object.assign(Object.assign({}, row.volumen_total_distribucion_baleares), FORMULAS.volumen({
                    periodo_actual: asNumber(row.volumen_total_distribucion_baleares.vol_aact),
                    periodo_anterior: asNumber(row.volumen_total_distribucion_baleares.vol_aant),
                    objetivo_porcentaje: asNumber(row.volumen_total_distribucion_baleares.propuesta_1_kpi),
                }));
                const clientes_total_distribucion_baleares = Object.assign(Object.assign({}, row.clientes_total_distribucion_baleares), FORMULAS.baleares_clientes_increment({
                    periodo_anterior: asNumber(row.clientes_total_distribucion_baleares.clientes_aant),
                    periodo_actual: asNumber(row.clientes_total_distribucion_baleares.clientes_aact),
                    objetivo_absoluto: asNumber(row.clientes_total_distribucion_baleares.propuesta_2_kpi),
                }));
                const volumen_total_vitrio_retornable_baleares = Object.assign(Object.assign({}, row.volumen_total_vitrio_retornable_baleares), FORMULAS.volumen({
                    periodo_actual: asNumber(row.volumen_total_vitrio_retornable_baleares.vol_esp_aact),
                    periodo_anterior: asNumber(row.volumen_total_vitrio_retornable_baleares.vol_esp_aant),
                    objetivo_porcentaje: asNumber(row.volumen_total_vitrio_retornable_baleares.propuesta_3_kpi),
                }));
                const clientes_total_vitrio_retornable_baleares = Object.assign(Object.assign({}, row.clientes_total_vitrio_retornable_baleares), FORMULAS.baleares_clientes_increment({
                    periodo_anterior: asNumber(row.clientes_total_vitrio_retornable_baleares.clientes_esp_aant),
                    periodo_actual: asNumber(row.clientes_total_vitrio_retornable_baleares.clientes_esp_aact),
                    objetivo_absoluto: asNumber(row.clientes_total_vitrio_retornable_baleares.propuesta_4_kpi),
                }));
                const result_field = row.variable_kpi_esp_baleares.tipo_5kpi === "Volumen"
                    ? asNumber(row.variable_kpi_esp_baleares.vol_esp_1_aact)
                    : asNumber(row.variable_kpi_esp_baleares.clientes_esp_1_aact);
                const variable_kpi_esp_baleares = Object.assign(Object.assign({}, row.variable_kpi_esp_baleares), FORMULAS.baleares_variable_kpi({
                    result_field,
                    objetivo_target: asNumber(row.variable_kpi_esp_baleares.propuesta_5_kpi),
                }));
                return {
                    delegacion: row.delegacion,
                    delegacion_zona_de_ventas: row.delegacion_zona_de_ventas,
                    zona_de_ventas: row.zona_de_ventas,
                    sala: row.sala,
                    tipo_de_ruta: row.tipo_de_ruta,
                    volumen_total_distribucion_baleares,
                    clientes_total_distribucion_baleares,
                    volumen_total_vitrio_retornable_baleares,
                    clientes_total_vitrio_retornable_baleares,
                    variable_kpi_esp_baleares,
                    ano_natural: period.year,
                    mes_natural: period.month,
                };
            }
            // Datos de CENTRO (por defecto)
            else {
                const centerRow = row;
                const volumen = FORMULAS.volumen({
                    periodo_actual: asNumber(centerRow.volumen.mes_year_actual),
                    periodo_anterior: asNumber(centerRow.volumen.mes_year_anterior),
                    objetivo_porcentaje: asNumber(centerRow.volumen.objetivo) / 100,
                });
                const volumen_acumulado = FORMULAS.volumen_acumulado({
                    periodo_actual: asNumber(centerRow.volumen_acumulado.acumulado_year_actual),
                    periodo_anterior: asNumber(centerRow.volumen_acumulado.acumulado_year_anterior),
                    objetivo_porcentaje: asNumber(centerRow.volumen_acumulado.objetivo) / 100,
                });
                const clientes = FORMULAS.clientes({
                    periodo_actual: asNumber(centerRow.clientes.clientes_mes_actual),
                    periodo_anterior: asNumber(centerRow.clientes.clientes_mes_anterior),
                });
                const ref_promedio = FORMULAS.ref_promedio({
                    periodo_actual: asNumber(centerRow.ref_promedio.ref_mes_year_actual),
                    periodo_anterior: asNumber(centerRow.ref_promedio.ref_mes_year_anterior),
                });
                const gda = FORMULAS.gda({
                    obj_ho_f1: centerRow.GDA.Grupo1.obj_ho_f1,
                    rtdo_ho_f1: centerRow.GDA.Grupo1.rtdo_ho_f1,
                    obj_ho_f2: centerRow.GDA.Grupo2.obj_ho_f2,
                    rtdo_ho_f2: centerRow.GDA.Grupo2.rtdo_ho_f2,
                    obj_ho_f3: centerRow.GDA.Grupo3.obj_ho_f3,
                    rtdo_ho_f3: centerRow.GDA.Grupo3.rtdo_ho_f3,
                    obj_al_f1: centerRow.GDA.Grupo4.obj_al_f1,
                    rtdo_al_f1: centerRow.GDA.Grupo4.rtdo_al_f1,
                    obj_al_f2: centerRow.GDA.Grupo5.obj_al_f2,
                    rtdo_al_f2: centerRow.GDA.Grupo5.rtdo_al_f2,
                    obj_al_f3: centerRow.GDA.Grupo6.obj_al_f3,
                    rtdo_al_f3: centerRow.GDA.Grupo6.rtdo_al_f3,
                });
                const porcentaje_cumplimiento = {
                    volumen: FORMULAS.total(volumen.porcentaje_conseguido),
                    volumen_acumulado: FORMULAS.total(volumen_acumulado.porcentaje_conseguido),
                    clientes: FORMULAS.porcentaje_cumplimiento_clientes(clientes.objetivo, clientes.periodo_actual),
                    ref_promedio: FORMULAS.total(ref_promedio.porcentaje_conseguido),
                    ho_f1: centerRow.GDA.Grupo1 && FORMULAS.gda_compliance(centerRow.GDA.Grupo1.obj_ho_f1, centerRow.GDA.Grupo1.rtdo_ho_f1),
                    ho_f2: centerRow.GDA.Grupo2 && FORMULAS.gda_compliance(centerRow.GDA.Grupo2.obj_ho_f2, centerRow.GDA.Grupo2.rtdo_ho_f2),
                    ho_f3: centerRow.GDA.Grupo3 && FORMULAS.gda_compliance(centerRow.GDA.Grupo3.obj_ho_f3, centerRow.GDA.Grupo3.rtdo_ho_f3),
                    al_f1: centerRow.GDA.Grupo4 && FORMULAS.gda_compliance(centerRow.GDA.Grupo4.obj_al_f1, centerRow.GDA.Grupo4.rtdo_al_f1),
                    al_f2: centerRow.GDA.Grupo5 && FORMULAS.gda_compliance(centerRow.GDA.Grupo5.obj_al_f2, centerRow.GDA.Grupo5.rtdo_al_f2),
                    al_f3: centerRow.GDA.Grupo6 && FORMULAS.gda_compliance(centerRow.GDA.Grupo6.obj_al_f3, centerRow.GDA.Grupo6.rtdo_al_f3),
                };
                const total_volumen = FORMULAS.total(volumen.porcentaje_conseguido);
                const total_volumen_acumulado = FORMULAS.total(volumen_acumulado.porcentaje_conseguido);
                return {
                    delegacion_zona_de_ventas: centerRow.delegacion_zona_de_ventas,
                    distribuidor: centerRow.distribuidor,
                    volumen,
                    volumen_acumulado,
                    clientes,
                    ref_promedio,
                    gda,
                    porcentaje_cumplimiento,
                    total_volumen,
                    total_volumen_acumulado,
                };
            }
        })));
    });
}
